<template>
  <app-layout />
</template>

<script>
import AppLayout from "./components/AppLayout.vue";

export default {
  name: "App",
  components: {
    AppLayout,
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  width: 100%;
}

#app {
  font-family:
    "PingFang SC", "Helvetica Neue", Helvetica, "Microsoft YaHei", "微软雅黑",
    Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}

/* 主题蓝色变量 */
:root {
  --primary-color: #6978e3;
  --primary-light: #8997fc;
  --primary-dark: #5767d1;
  --secondary-color: #8997fc;
  --text-on-primary: #ffffff;
  --background-color: #f5f7fa;
}

/* 响应式布局断点 */
@media screen and (max-width: 768px) {
  html {
    font-size: 14px;
  }
}
</style>
